module.exports = __webpack_public_path__ + "static/img/48050.32c3398.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/48050.jpg
// module id = DTAL
// module chunks = 1